export enum ReservaEstadosEnum {
    Borrador = '1',
    Pendiente = '2',
    Reservado = '3',
    Cancelado = '4',
    Finalizado = '5',
}